import dayjs from 'dayjs';

import { CURRENCIES_SETTING } from 'constants/core-constants';
import {
  ORDER_STATUSES_ENUM,
  OrderFullInfoType,
  PAYMENT_TYPE_ENUM,
} from 'types/tickets/tickets.types';

export const orderContent = (orderFullInfo: OrderFullInfoType) => {
  if (orderFullInfo) {
    return [
      [
        {
          title: 'Event Name',
          content: orderFullInfo?.tickets[0]?.event?.eventName,
        },
        {
          title: 'Tickets',
          content: orderFullInfo?.tickets?.length,
        },
        {
          title: 'Order Status',
          content: ORDER_STATUSES_ENUM[orderFullInfo?.orderStatus],
        },
        ...(orderFullInfo.paymentType === 'creditCard'
          ? [
              {
                title: 'Card Country',
                content: orderFullInfo?.cardDetails?.cardCountry ?? 'N/A',
              },
              {
                title: 'Order Country',
                content: orderFullInfo?.country ?? 'N/A',
              },
            ]
          : orderFullInfo.paymentType === 'complimentary'
          ? [
              {
                title: 'Order Country',
                content: orderFullInfo?.country ?? 'N/A',
              },
            ]
          : []),
        ...(orderFullInfo.paymentType === 'cash'
          ? [
              {
                title: 'Card Payment Type',
                content: orderFullInfo?.cashPaymentType ?? 'N/A',
              },
            ]
          : []),
      ],
      [
        {
          title: 'Order Number',
          content: orderFullInfo?.orderNo,
        },
        {
          title: 'Order Date',
          content: dayjs(orderFullInfo?.orderDate).format('DD MMM YYYY, HH:mm'),
        },
        {
          title: 'Order Total',
          content: `${CURRENCIES_SETTING[orderFullInfo?.currency?.toUpperCase() ?? '']?.symbol}${
            orderFullInfo?.orderSubTotal
          }`,
        },
        ...(orderFullInfo.paymentType === 'creditCard'
          ? [
              {
                title: 'Card Number',
                content: orderFullInfo?.cardDetails.cardNumber ?? 'N/A',
              },
            ]
          : []),
      ],
      [
        {
          title: 'Buyer Name',
          content: orderFullInfo?.user?.fullName,
        },
        {
          title: 'Buyer Email',
          content: orderFullInfo?.user?.email,
        },
        {
          title: 'Payment Type',
          content: PAYMENT_TYPE_ENUM[orderFullInfo?.paymentType],
        },
        ...(orderFullInfo.paymentType === 'creditCard'
          ? [
              {
                title: 'Card Expiry',
                content: orderFullInfo?.cardDetails.cardExpiry ?? 'N/A',
              },
            ]
          : []),
      ],
    ];
  }
};
